import React, { Fragment, useContext, useState } from "react";
import { LogIn, MoreHorizontal } from "react-feather";
import { Media } from "reactstrap";
import { Link } from "react-router-dom";
import { LI, UL } from "../../AbstractElements";
import MaxMiniSize from "./MaxMiniSize";
import MoonLight from "./MoonLight";
import AuthContext from "../../Context/AuthContext";
// import Notifications from "./Notification";

const HeaderContain = () => {
  const { logoutUser } = useContext(AuthContext);

  const [open, setOpen] = useState(false);
  const onAdd = () => {
    setOpen(!open);
  };

  return (
    <Fragment>
      <div className="nav-right col pull-right right-menu">
        <UL
          attrUL={{
            className: `simple-list d-flex flex-row nav-menus ${
              open ? "open" : ""
            }`,
          }}
        >
          <LI attrLI={{ className: "onhover-dropdown" }}>
            <a className="txt-dark" href="#javascript"></a>
          </LI>
          {/* <Notifications /> */}
          <MoonLight />
          <MaxMiniSize />
          <LI attrLI={{ className: "onhover-dropdown" }}>
            <Media body>
              <span>{localStorage.getItem("username")}</span>
            </Media>
            <UL
              attrUL={{
                className: "simple-list profile-dropdown onhover-show-div",
              }}
            >
              <LI attrLI={{ onClick: logoutUser }}>
                <Link
                  to={`${process.env.PUBLIC_URL}/login`}
                  className="btn btn-light w-100"
                >
                  <LogIn /> Logout
                </Link>
              </LI>
            </UL>
          </LI>
        </UL>
      </div>
      <div
        className="d-lg-none col mobile-toggle pull-right"
        onClick={() => onAdd()}
      >
        <i>
          <MoreHorizontal />
        </i>
      </div>
    </Fragment>
  );
};
export default HeaderContain;
